function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "products_modern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12957"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1258",
    d: "M101.178 248.684v-5.772a.224.224 0 0 1 .185-.254c1.244-.4 2.485-.808 3.727-1.212.061-.02.123-.036.208-.06v5.761c0 .161-.056.217-.2.263q-1.839.591-3.672 1.2a1.5 1.5 0 0 0-.168.079z",
    transform: "translate(-93.882 -226.686)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1259",
    d: "M303.718 248.666v-5.791c0-.112.012-.181.145-.224 1.281-.411 2.56-.829 3.839-1.246.036-.012.073-.021.134-.039v5.4c0 .448-.112.6-.55.741l-3.318 1.084a1.5 1.5 0 0 0-.168.079z",
    transform: "translate(-285.837 -226.671)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1260",
    d: "M206.45 248.687a1.4 1.4 0 0 0-.168-.08l-3.673-1.2c-.143-.046-.2-.1-.2-.262.008-1.853.005-3.707.005-5.56v-.2c.08.022.145.037.209.056 1.243.4 2.484.813 3.729 1.213a.224.224 0 0 1 .183.257q-.008 2.886 0 5.769z",
    transform: "translate(-189.824 -226.69)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1261",
    d: "M4.038 248.6a1.087 1.087 0 0 0-.15-.076q-1.707-.56-3.417-1.115a.584.584 0 0 1-.472-.6v-5.393c0-.031.005-.063.01-.117l1.08.352c.947.309 1.893.62 2.841.922a.224.224 0 0 1 .188.252q-.008 2.888 0 5.776z",
    transform: "translate(2.004 -226.602)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1262",
    d: "M106.448 0c.521.177 1.041.357 1.564.529l2.744.9c.06.02.118.044.215.08l-.224.08-4.284 1.4a.488.488 0 0 1-.28.014c-1.512-.486-3.018-.979-4.578-1.487.107-.04.172-.066.239-.088L105.962.08a1.884 1.884 0 0 0 .173-.08z",
    transform: "translate(-94.29 2.001)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1263",
    d: "M206.533 53.22v6.067l-4.112 1.344v-5.872a.232.232 0 0 1 .2-.266c1.239-.4 2.477-.8 3.714-1.206l.206-.066",
    transform: "translate(-189.832 -48.495)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1264",
    d: "m105.494 60.573-4.1-1.339v-6.069l1.661.542c.761.248 1.522.5 2.284.742.112.035.168.076.168.209q-.008 2.9 0 5.795c0 .032 0 .063-.006.121",
    transform: "translate(-94.088 -48.443)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1265",
    d: "m.68 189.486.208-.077 4.3-1.4a.457.457 0 0 1 .26-.015q2.229.719 4.455 1.45c.028.009.056.022.126.052-.323.107-.6.2-.884.293q-1.817.594-3.636 1.184a.457.457 0 0 1-.26.017q-2.22-.716-4.435-1.445c-.034-.011-.067-.026-.137-.056",
    transform: "translate(1.359 -176.156)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1266",
    d: "m212.564 189.488-3.392 1.107c-.377.123-.752.254-1.132.365a.6.6 0 0 1-.333 0q-2.146-.691-4.287-1.4c-.059-.02-.117-.043-.212-.077.085-.034.134-.056.186-.074q2.161-.706 4.322-1.409a.456.456 0 0 1 .26-.017q2.23.719 4.455 1.449c.028.01.056.022.133.056",
    transform: "translate(-190.582 -176.152)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsModern);
export default __webpack_public_path__ + "static/media/products_modern.b8e79478a895999748e6ef0cf40676c4.svg";
export { ForwardRef as ReactComponent };